import { useEffect, useState } from "react";
import { addLink, fetchRawThematics } from "../../HTTP/thematics";
import { countries } from "../../global/countriesAndSources";

export default function AddLinksThematic() {
    const localUser = JSON.parse(localStorage.getItem("user"))
    if (!localUser.super_admin && localUser.admin_access !== 6) {
        window.location.href = '/'
    }

    const [thematics, setThematics] = useState([])
    const [formData, setFormData] = useState({
        id : 0,
        thematic_id: 0,
        thematic_ids: [],
        country: '',
        label: '',
        link: ''
    });
    
    // États pour la recherche de pays
    const [countrySearch, setCountrySearch] = useState('');
    const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
    const [filteredCountries, setFilteredCountries] = useState(countries);

    useEffect(() => {
        const fetchThematics = async () => {
            const res = await fetchRawThematics()
            setThematics(res)
        }
        fetchThematics()
    }, [])

    // Filtrer les pays en fonction de la recherche
    useEffect(() => {
        if (countrySearch.trim() === '') {
            setFilteredCountries(countries);
        } else {
            const filtered = countries.filter(country =>
                country.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
                country.code.toLowerCase().includes(countrySearch.toLowerCase())
            );
            setFilteredCountries(filtered);
        }
    }, [countrySearch]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handleMultiChange = (e) => {
        setFormData({
            ...formData,
            thematic_ids: Array.from(e.target.selectedOptions, (o) => Number(o.value))
        })
    }

    const handleCountrySearchChange = (e) => {
        setCountrySearch(e.target.value);
        setIsCountryDropdownOpen(true);
    }

    const handleCountrySelect = (countryCode, countryName) => {
        setFormData({
            ...formData,
            country: countryCode
        });
        setCountrySearch(countryName);
        setIsCountryDropdownOpen(false);
    }

    const handleCountryInputFocus = () => {
        setIsCountryDropdownOpen(true);
    }

    const handleCountryInputBlur = () => {
        // Délai pour permettre le clic sur une option
        setTimeout(() => {
            setIsCountryDropdownOpen(false);
        }, 200);
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const res = await addLink({id: formData.id, thematic_id: formData.thematic_id, thematic_ids: formData.thematic_ids, country: formData.country, label: formData.label, link: formData.link})
        if (res) {
            alert("Link added")
            window.location.href = `/admin/linksthematics?page=1&country=${formData.country}`
        } else {
            alert("Une erreur est survenue lors de la mise à jour du lien.")
        }
    }

    // Obtenir le nom du pays sélectionné
    const getSelectedCountryName = () => {
        if (formData.country === 'wd') return 'Tous les pays';
        const selectedCountry = countries.find(country => country.code === formData.country);
        return selectedCountry ? selectedCountry.name : '';
    }

    return (
        <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-6 text-center">Ajouter un lien thématique</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="thematic_id" className="block text-gray-700 text-sm font-bold mb-2">
                        Thématique
                    </label>
                    <select
                        name="thematic_id"
                        id="thematic_id"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={handleChange}
                        value={formData.thematic_id}
                        required
                    >
                        <option value="">Sélectionner une thématique</option>
                        {thematics.map((thematic) => (
                            <option key={thematic.id} value={thematic.id}>
                                {thematic.path || thematic.name}
                            </option>
                        ))}
                    </select>
                    <label htmlFor="thematic_ids" className="block text-gray-700 text-sm font-bold mt-3 mb-2">
                        Autres thématiques rattachées (facultatif)
                    </label>
                    <select
                        multiple
                        name="thematic_ids"
                        id="thematic_ids"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm h-40"
                        onChange={handleMultiChange}
                        value={(formData.thematic_ids || []).map(String)}
                    >
                        {thematics.filter((t) => String(t.id) !== String(formData.thematic_id)).map((thematic) => (
                            <option key={thematic.id} value={thematic.id}>
                                {thematic.path || thematic.name}
                            </option>
                        ))}
                    </select>
                </div>
                
                <div className="mb-4 relative">
                    <label htmlFor="country" className="block text-gray-700 text-sm font-bold mb-2">
                        Code pays
                    </label>
                    <input
                        type="text"
                        placeholder="Rechercher un pays..."
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        value={countrySearch}
                        onChange={handleCountrySearchChange}
                        onFocus={handleCountryInputFocus}
                        onBlur={handleCountryInputBlur}
                    />
                    
                    {isCountryDropdownOpen && (
                        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
                            <div
                                className="px-3 py-2 hover:bg-blue-50 cursor-pointer border-b"
                                onClick={() => handleCountrySelect('wd', 'Tous les pays')}
                            >
                                <div className="font-medium">Tous les pays</div>
                            </div>
                            {filteredCountries.map((country) => (
                                <div
                                    key={country.code}
                                    className="px-3 py-2 hover:bg-blue-50 cursor-pointer"
                                    onClick={() => handleCountrySelect(country.code, country.name)}
                                >
                                    <div className="font-medium">{country.name}</div>
                                </div>
                            ))}
                            {filteredCountries.length === 0 && (
                                <div className="px-3 py-2 text-gray-500 text-center">
                                    Aucun pays trouvé
                                </div>
                            )}
                        </div>
                    )}
                    
                    {/* Champ caché pour la validation du formulaire */}
                    <input
                        type="hidden"
                        name="country"
                        value={formData.country}
                        required
                    />
                    
                    {/* Affichage du pays sélectionné */}
                    {formData.country && (
                        <div className="mt-2 text-sm text-gray-600">
                            Sélectionné: {getSelectedCountryName()} ({formData.country})
                        </div>
                    )}
                </div>
                
                <div className="mb-4">
                    <label htmlFor="label" className="block text-gray-700 text-sm font-bold mb-2">
                        Label
                    </label>
                    <input
                        type="text"
                        name="label"
                        id="label"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={handleChange}
                        value={formData.label}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="link" className="block text-gray-700 text-sm font-bold mb-2">
                        Lien
                    </label>
                    <input
                        type="text"
                        name="link"
                        id="link"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={handleChange}
                        value={formData.link}
                        required
                    />
                </div>
                <div className="flex items-center justify-end">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                        Enregistrer
                    </button>
                </div>
            </form>
        </div>
    )
}